<div class="modal-module h-full flex flex-col justify-between">
	<div class="modalHeader">
		<div class="flex">
			<div class="titleNewModule">
				<span>
					{{ data?.type === 'update' ? translateModal?.titleUpdate : translateModal?.title }}
				</span>
			</div>
			<div class="closeModal">
				<mat-icon (click)="onNoClick()">close</mat-icon>
			</div>
		</div>
	</div>
	<div class="modalContent overflow-y-auto h-full justify-between flex flex-col min-h-[323px]">
		<form class="w-full h-full pt-4" [formGroup]="formVersion">
			<div class="form-group">
				<label for="version"> {{ translateModal.version }} <span class="asteriks">*</span></label>
				<input
					type="text"
					class="input-app"
					name="version"
					id="version"
					formControlName="version"
					[placeholder]="translateModal.version"
				/>
				<div *ngIf="f.version.touched && f.version.invalid" class="alert-error">
					<div *ngIf="f.version.errors?.required">{{ translateModal.nameRequired }}</div>
					<div *ngIf="f.version?.errors?.['pattern']">
						{{ translateModal.invalidFormat }}
					</div>
				</div>
			</div>
			<div class="form-group">
				<label for="date"> {{ translateModal.date }} <span class="asteriks">*</span></label>
				<input
					type="date"
					class="input-app"
					name="date"
					id="date"
					formControlName="date"
					[placeholder]="translateModal.date"
				/>
				<div *ngIf="f.date.touched && f.date.invalid" class="alert-error">
					<div *ngIf="f.date.errors?.required">{{ translateModal.nameRequired }}</div>
				</div>
			</div>
			<div class="features">
				<div class="flex justify-between">
					<label for="features">{{ translateModal.titleFeature }} </label>
					<button class="mg-button primaryButton buttonAdd" (click)="addFeatures()">
						<mat-icon>add</mat-icon> <span> {{ translateModal.buttonAdd }} </span>
					</button>
				</div>
				<div class="w-full flex flex-col pt-[0.45rem] gap-2">
					<div
						class="w-full flex justify-between items-center"
						*ngFor="let feature of features.controls; let index = index"
						formArrayName="features"
					>
						<textarea
							class="input-app min-h-[33px] !px-[12px] !pt-[4px]"
							type="text"
							[placeholder]="translateModal.textFeature + ' #' + (index + 1)"
							[formControlName]="index"
						></textarea>
						<mat-icon class="cursor-pointer text-[red]" (click)="removeFeatures(index)"
							>delete</mat-icon
						>
					</div>
				</div>
			</div>
			<div class="improvements pt-3">
				<div class="flex justify-between">
					<label for="improvements"> {{ translateModal.titleBug }} </label>
					<button class="mg-button primaryButton buttonAdd" (click)="addImprovements()">
						<mat-icon>add</mat-icon> <span> {{ translateModal.buttonAdd }} </span>
					</button>
				</div>
				<div class="w-full flex flex-col pt-[0.45rem] gap-2">
					<div
						class="w-full flex justify-between items-center"
						*ngFor="let improvement of improvements.controls; let index = index"
						formArrayName="improvements"
					>
						<textarea
							class="input-app min-h-[33px] !px-[12px] !pt-[4px]"
							type="text"
							[placeholder]="translateModal.textBug + ' #' + +(index + 1)"
							[formControlName]="index"
						></textarea>
						<mat-icon class="cursor-pointer text-[red]" (click)="removeImprovements(index)"
							>delete</mat-icon
						>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div class="footer-modal">
		<div class="px-2">
			<button class="mg-button secundaryButton" (click)="onNoClick()">
				{{ translateModal.buttonCancel }}
			</button>
		</div>
		<div class="pl-2">
			<button class="mg-button primaryButton" (click)="save()" [disabled]="formVersion.invalid">
				{{ translateModal.buttonSave }}
			</button>
		</div>
	</div>
</div>
